// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  riderBffUrl: 'https://api.dev.simpexo.com/riderWebapp',
  firebase: {
    apiKey: 'AIzaSyAWOx2t4ljtaUiFIOW_BIlgjLwCXbOFeh8',
    authDomain: 'simpayx.firebaseapp.com',
    databaseURL: 'https://simpayx.firebaseio.com',
    projectId: 'simpayx',
    storageBucket: 'simpayx.appspot.com',
    messagingSenderId: '263999792826',
    appId: '1:263999792826:web:cf202ca8daeda397d1c483',
    measurementId: 'G-HMRZD6S0X0',
  },
  RIDER_JOBS: "RiderJobs",
  RIDERS: "Riders",
  otpWidgetId: '346c73695671363933313637',
  msg91AuthToken: '412274ThGim5Bv6763edfdP1',
  ORDERS: 'Orders',
  DSN_FOR_SENTRY: 'https://687d98aaa1bb2cbd61ac7555332cfc89@o4509948943335424.ingest.us.sentry.io/4510005907030016',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
